import { CircularProgressProps } from '@mui/material/CircularProgress';
import {
  Typography,
  CircularProgress as MuiCircularProgress,
} from '@mui/material';
import Box from '@mui/material/Box';

export const CircularProgress = (
  props: CircularProgressProps & { value?: number }
) => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        width: 100,
        height: 100,
      }}
    >
      <MuiCircularProgress variant="determinate" size="100%" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {props.value !== undefined && (
          <Typography
            component="div"
            sx={{
              fontSize: 18,
              fontWeight: 600,
              color: '#0f5fff',
            }}
          >{`${Math.round(props.value)}%`}</Typography>
        )}
      </Box>
    </Box>
  );
};
